// News feed (parts/Blog SEO "News hub"): names today and yesterday on the day dividers, in the store's time zone offset, and
// filters the rows by source. Without JavaScript the dividers show the date and the filters stay hidden.

// The calendar day ("YYYY-MM-DD") at `nowMs` in a fixed offset such as "-0600" (Liquid's %z of the store's time zone).
export function todayKey(nowMs, offset = '+0000') {
  const match = /^([+-])(\d{2}):?(\d{2})$/.exec(String(offset).trim());
  const minutes = match ? (match[1] === '-' ? -1 : 1) * (Number(match[2]) * 60 + Number(match[3])) : 0;
  return new Date(nowMs + minutes * 60000).toISOString().slice(0, 10);
}

// "today", "yesterday" or "" for a day key against today's key.
export function dayWord(day, today) {
  if (day === today) return 'today';
  const before = new Date(`${today}T00:00:00Z`);
  before.setUTCDate(before.getUTCDate() - 1);
  return day === before.toISOString().slice(0, 10) ? 'yesterday' : '';
}

// Whether a row of this source shows under the picked filter.
export function shows(source, picked) {
  return picked === 'all' || source === picked;
}

if (typeof document !== 'undefined') {
  const names = root => {
    const today = todayKey(Date.now(), root.getAttribute('data-offset') ?? '+0000');
    for (const word of root.querySelectorAll('[data-ns-day]')) {
      const kind = dayWord(word.getAttribute('data-ns-day'), today);
      const text = kind ? root.getAttribute(`data-${kind}`) : '';
      if (!text) continue;
      word.textContent = `${text} · `;
      word.hidden = false;
    }
  };
  const apply = (root, picked) => {
    let any = false;
    for (const day of root.querySelectorAll('[data-ns-news-day]')) {
      let visible = 0;
      for (const row of day.querySelectorAll('[data-ns-source]')) {
        row.hidden = !shows(row.getAttribute('data-ns-source'), picked);
        if (!row.hidden) visible += 1;
      }
      day.hidden = visible === 0;
      any ||= visible > 0;
    }
    const none = root.querySelector('[data-ns-news-none]');
    if (none) none.hidden = any;
  };
  for (const root of document.querySelectorAll('[data-ns-news]')) {
    names(root);
    const filters = root.querySelector('[data-ns-news-filters]');
    if (!filters) continue;
    filters.hidden = false;
    let picked = 'all';
    filters.addEventListener('click', event => {
      const button = event.target.closest('button[data-ns-source]');
      if (!button) return;
      picked = button.getAttribute('data-ns-source');
      for (const other of filters.querySelectorAll('button[data-ns-source]')) other.setAttribute('aria-pressed', String(other === button));
      apply(root, picked);
    });
    // Load more appends rows: keep the filter and the day names on them.
    new MutationObserver(() => { names(root); apply(root, picked); }).observe(root.querySelector('[data-ns-results]') ?? root, { childList: true });
  }
}
